module.exports = __webpack_public_path__ + "img/React_logo_wordmark.e30f4db5.png";